import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RxDropdownMenu } from "react-icons/rx";
import { MdModeEdit } from "react-icons/md";
import { MdDelete } from "react-icons/md";
import ConfirmationModal from "../../../../common/ConfirmationModal";
import { MdArrowDropDown } from "react-icons/md";
import { MdAdd } from "react-icons/md";
import SubSectionModal from "./SubSectionModal";
import {
  deleteSection,
  deleteSubSection,
} from "../../../../../services/operations/courseDetailsAPI";
import { setCourse } from "../../../../../slices/courseSlice";

function NestedView({ handleChangeEditSectionName }) {
  const { course } = useSelector((state) => state.course);
  const { token } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [addSubSection, setAddSubSection] = useState(null);
  const [viewSubSection, setViewSubSection] = useState(null);
  const [editSubSection, setEditSubSection] = useState(null);
  const [confirmationModal, setConfirmationModal] = useState(null);

  async function handleDeleteSection(sectionId) {
    const result = await deleteSection(
      {
        sectionId,
        courseId: course._id,
        // changed courseID to courseId
      },
      token
    );

    // is result is valid
    // console.log("Result in Nestedview deletesection", result);
    if (result) {
      dispatch(setCourse(result));
    }
    setConfirmationModal(null);
  }

  async function handleDeleteSubSection(subSectionId, sectionId) {
    const result = await deleteSubSection({ subSectionId, sectionId }, token);

    /*
      Issue and how it was fixed
      issue was when we were deleting any section it was getting deleted but the
      ui was not getting re rendered because in the course slice we were adding the data
      of section but course cannot be updated using section it will need
      an course data to be updated so what we did was 
      to create and updated course by removing the data and replacing it with new data
      and then copying previous data and adding new courseContent Data
    */

    // if result is valid (not null)
    // console.log("Result in Nestedview deletesubsection", result);
    if (result) {
      // what can we add here
      const updatedCourseContent = course.courseContent.map((section) =>
        section._id === sectionId ? result : section
      );
      // courseContent is array in course model which contains sections
      const updatedCourse = { ...course, courseContent: updatedCourseContent };
      // course has previous data courseContent now stores updated data

      dispatch(setCourse(updatedCourse));
    }
    confirmationModal(null);
  }

  return (
    <div className="relative">
      <div className="mt-5 bg-richblack-700 py-6 px-4 rounded-md border border-richblack-400">
        {course?.courseContent?.map((section) => {
          // console.log("Updated");
          return (
            <details key={section._id} open>
              <summary className="flex items-center justify-between gap-x-3 border-b">
                <div className="flex items-center gap-x-2">
                  <RxDropdownMenu className="text-white text-lg" />
                  <p className="text-white">{section.sectionName}</p>
                </div>
                <div className="flex items-center gap-x-4">
                  <button
                    onClick={() =>
                      handleChangeEditSectionName(
                        section._id,
                        section.sectionName
                      )
                    }>
                    <MdModeEdit className="text-lg" />
                  </button>
                  <button
                    onClick={() => {
                      setConfirmationModal({
                        text1: "Delete this section",
                        text2:
                          "All the lectures in this section will be deleted",
                        btn1Text: "Delete",
                        btn2Text: "Cancel",
                        btn1Handler: () => {
                          handleDeleteSection(section._id);
                        },
                        btn2Handler: () => {
                          setConfirmationModal(null);
                        },
                      });
                    }}>
                    <MdDelete className="text-lg" />
                  </button>
                  <span>|</span>
                  {/* <button> */}
                    {/* <MdArrowDropUp /> */}
                    <MdArrowDropDown className="text-lg" />
                  {/* </button> */}
                </div>
              </summary>
              <div>
                {section.subSection.map((data) => {
                  return (
                    <div
                      key={data._id}
                      onClick={() => {
                        setViewSubSection(true);
                      }}
                      className="flex items-center justify-between gap-x-3 border-b">
                      <div className="flex items-center gap-x-2">
                        <RxDropdownMenu className="text-white text-lg" />
                        <p className="text-white">{data.title}</p>
                      </div>
                      <div onClick={(e)=>e.stopPropagation()} className="flex items-center gap-x-3">
                        <button
                          onClick={() => {
                            setEditSubSection({
                              ...data,
                              sectionID: section._id,
                            });
                          }}>
                          <MdModeEdit className="text-lg" />
                        </button>
                        <button
                          onClick={() => {
                            setConfirmationModal({
                              text1: "Delete this sub section",
                              text2: "Selected lecture will be deleted",
                              btn1Text: "Delete",
                              btn2Text: "Cancel",
                              btn1Handler: () => {
                                handleDeleteSubSection(data._id, section._id);
                              },
                              btn2Handler: () => {
                                setConfirmationModal(null);
                              },
                            });
                          }}>
                          <MdDelete className="text-lg" />
                        </button>
                      </div>
                    </div>
                  );
                })}
                <button
                  onClick={() => {
                    setAddSubSection(section._id);
                  }}
                  className="flex items-center mt-5 text-yellow-25 gap-x-2">
                  <MdAdd />
                  <p>Add Lectures</p>
                </button>
              </div>
            </details>
          );
        })}
      </div>

      {/* confirmation modal */}
      {addSubSection ? (
        <SubSectionModal
          modalData={addSubSection}
          setModalData={setAddSubSection}
          add={true}
        />
      ) : viewSubSection ? (
        <SubSectionModal
          modalData={viewSubSection}
          setModalData={setViewSubSection}
          view={true}
        />
      ) : editSubSection ? (
        <SubSectionModal
          modalData={editSubSection}
          setModalData={setEditSubSection}
          edit={true}
        />
      ) : (
        <div></div>
      )}

      {confirmationModal ? (
        <ConfirmationModal modalData={confirmationModal} />
      ) : (
        <div></div>
      )}
    </div>
  );
}

export default NestedView;
